/**
 * Local progress tracking for the "Learn How to Read" curriculum. Mirrors
 * lib/bookmarks.ts's local-first pattern (no cloud sync for this yet - could
 * follow the same bookmarksSync.ts approach later if wanted).
 */
const PROGRESS_STORAGE_KEY = 'quranLearnProgress'
export const LEARN_PROGRESS_CHANGED_EVENT = 'quran:learn-progress-changed'

export function loadCompletedLessonIds(): Set<string> {
  if (typeof window === 'undefined') return new Set()
  try {
    const raw = window.localStorage.getItem(PROGRESS_STORAGE_KEY)
    if (!raw) return new Set()
    const parsed = JSON.parse(raw)
    return new Set(Array.isArray(parsed) ? parsed : [])
  } catch {
    return new Set()
  }
}

function saveCompletedLessonIds(ids: Set<string>) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(PROGRESS_STORAGE_KEY, JSON.stringify([...ids]))
  window.dispatchEvent(new CustomEvent(LEARN_PROGRESS_CHANGED_EVENT))
}

export function isLessonComplete(lessonId: string): boolean {
  return loadCompletedLessonIds().has(lessonId)
}

export function markLessonComplete(lessonId: string) {
  const ids = loadCompletedLessonIds()
  ids.add(lessonId)
  saveCompletedLessonIds(ids)
}

export function markLessonIncomplete(lessonId: string) {
  const ids = loadCompletedLessonIds()
  ids.delete(lessonId)
  saveCompletedLessonIds(ids)
}
